'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Grid = require('./Grid');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Grid).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/Grid/index.js
// module id = 5566
// module chunks = 39